import React, { useState } from 'react';
import './BetaAccessGate.css';

const BETA_ACCESS_CODE = '210C';

function BetaAccessGate({ onAccessGranted }) {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!code.trim()) {
      setError('Please enter your access code.');
      return;
    }

    if (code.trim().toUpperCase() === BETA_ACCESS_CODE) {
      localStorage.setItem('betaAccessVerified', 'true');
      onAccessGranted();
    } else {
      setError('Invalid access code. Please try again.');
      setCode('');
    }
  };

  return (
    <div className="beta-gate-page">
      <div className="beta-gate-container">
        <div className="beta-gate-card">
          <div className="beta-gate-header">
            <a href="/" className="beta-gate-logo" aria-label="CerebralMachines home">
              <img src="/CMLogo.png" alt="CerebralMachines" />
            </a>
            <div className="beta-gate-badge">Private Beta</div>
            <h1>Private Beta Preview</h1>
            <p>
              CerebralMachines is in private beta preview mode. Please enter
              your access code to gain access to the platform.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="beta-gate-form">
            {error && <div className="beta-gate-error">{error}</div>}

            <div className="beta-gate-field">
              <label htmlFor="accessCode">Access Code</label>
              <input
                type="text"
                id="accessCode"
                value={code}
                onChange={(e) => {
                  setCode(e.target.value);
                  if (error) setError('');
                }}
                placeholder="Enter your access code"
                autoFocus
                autoComplete="off"
              />
            </div>

            <button type="submit" className="beta-gate-button">
              Enter Platform
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default BetaAccessGate;
